/// <reference path="../../app.definition.ts" />

import angular from "angular";
import moment from "moment";


export interface IUtilityService {
    printLayout(arg0: string): unknown;
    printPDF(): unknown;
    stringContains(s1: string, s2: string): boolean;
    stringContains(s1: string, s2: string, matchCase: boolean): boolean;
    dateBetween(d: Date, startDate: Date, endDate: Date): boolean;
    replaceInList(list: Array<any>, obj: any, param?: string): Array<any>;
    toTitleCase(input: string): string;
    removeExtraSpace(input: string): string;
    stopEventPropogation(event: Event): void;
    setURLPlaceholder(editor): void;
    capitalize(str: string): string;
    convertToPercentage(pixelVal, totalVal): number;
    convertTopixel(percentageVal, totalVal): number;
    getMin(data, key): any;
    getMax(data, key): any;
    getFileExtension(filename): string;
    getTitleWthExt(post): string;
    getFileName(filename): string;
    getFileSize(bytes): string;
}

export class UtilityService implements IUtilityService {
    svcName: string = 'UtilityService';

    static $inject = [];
    constructor() { }

    printLayout = (function () {
        var head = document.head || document.getElementsByTagName('head')[0],
            style = document.createElement('style');
        style.type = 'text/css';
        style.media = 'print';
        head.appendChild(style);
        return function (layout) {
            style.innerHTML = '@page { size: ' + layout + '; }';
        }
    })();

    stringContains(s1: string, s2: string, matchCase?: boolean): boolean {
        if (!s1 || s2 == '' || !s2 || s2 == '') {
            return false;
        }

        let s1tmp = !!matchCase ? s1 : s1.toLowerCase();
        let s2tmp = !!matchCase ? s2 : s2.toLowerCase();

        return s1tmp.indexOf(s2tmp) > -1;
    }

    dateBetween(d, startDate, endDate) {
        //an undefined startDate is converted to the beginning of time
        startDate = startDate || 0;
        const granularity = null // can be 'days', ... see momentJS doc

        return moment(d).isBetween(startDate, endDate, granularity, '[]');
    }

    replaceInList(list: Array<any>, obj: any, param?: string): Array<any> {
        return list.map(listObj => this.equals(listObj, obj) ? obj : listObj);
    }

    private equals(obj1: any, obj2: any, param?: string): boolean {
        return !!param ? obj1[param] == obj2[param] : obj1 == obj2
    }


    toTitleCase(input: string): string {
        var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

        input = input.toLowerCase();
        return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
            if (index > 0 && index + match.length !== title.length &&
                match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
                (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                title.charAt(index - 1).search(/[^\s-]/) < 0) {
                return match.toLowerCase();
            }

            if (match.substr(1).search(/[A-Z]|\../) > -1) {
                return match;
            }

            return match.charAt(0).toUpperCase() + match.substr(1);
        });
    }

    removeExtraSpace(input: string): string {
        return input.trim().toLowerCase().replace(/\s\s+/g, ' ');
    }

    stopEventPropogation(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }

    setURLPlaceholder(editor) {
        var tooltip = editor.theme.tooltip;
        var input = tooltip.root.querySelector("input[data-link]");
        input.dataset.link = 'Type the URL here:';
    }

    capitalize = function (str: string) {
        if (str) {
            return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
        }
        return '';
    }

    convertToPercentage = (pixelVal, totalVal): number => {
        return (pixelVal * 100 / totalVal);
    };

    convertTopixel = (percentageVal, totalVal): number => {
        return (percentageVal * totalVal / 100);
    };

    printPDF = () => {
        var printContainer = $('#printContainer');
        var canvasWrapper = $('.canvasWrapper');
        this.printLayout('portrait');
        canvasWrapper.ready(() => {
            var canvas = canvasWrapper.find('canvas')[0] as HTMLCanvasElement;
            var img = document.createElement('img');
            img.style.width = `${canvas.width}px`;
            img.style.height = `${canvas.height}px`;
            if ('toBlob' in canvas) {
                canvas.toBlob(function (blob) {
                    img.src = URL.createObjectURL(blob);
                });
            } else {
                img.src = (canvas as HTMLCanvasElement).toDataURL();
            }
            var wrapper = document.createElement('div');
            wrapper.appendChild(img);
            printContainer.children().remove();
            printContainer.append($(wrapper));
            img.onload = function () {
                window.print();
            }
        })

    };
    cloneCanvasContext = (canvas, clonnedCanvas) => {
        if (canvas && clonnedCanvas) {
            var originalContext = canvas.getContext("2d");
            var imageData = originalContext.getImageData(0, 0, canvas.width, canvas.height);
            var cloneContext = clonnedCanvas.getContext("2d");
            cloneContext.putImageData(imageData, 0, 0);
        }
    };

    getMin = (data, key) => {
        if (Array.isArray(data)) {
            return Math.min.apply(Math, data.map(function (o) { return o[key]; }))
        } else {
            throw ("getMin => data is not an array. ");
        }
    };

    getMax = (data, key) => {
        if (Array.isArray(data)) {
            return Math.max.apply(Math, data.map(function (o) { return o[key]; }))
        } else {
            throw ("getMax => data is not an array. ");
        }
    };

    getValuesFromObject = (obj) => {
        var res = [];
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                res.push(obj[i]);
            }
        }
        return res;
    };

    getRangeValues = (data, key, size, secondaryKey) => {
        var rtnArr = [];
        size = size ? size : 10;
        if (Array.isArray(data) && data.length > 0) {
            var numberOfPages = Math.ceil(data.length / size);
            for (let i = 0; i < numberOfPages; i++) {
                let page = i + 1;
                let sIndex = i * size;
                let eIndex = sIndex + size - 1;
                if ((numberOfPages - 1) == i) {
                    let mod = (data.length % size);
                    eIndex = sIndex + (mod == 0 ? size : mod) - 1;
                }
                let firstPageVal = (data[sIndex][key] || data[sIndex][secondaryKey] || "");
                let lastPageVal = (data[eIndex][key] || data[eIndex][secondaryKey] || "");
                firstPageVal = (firstPageVal.length > 2) ? firstPageVal.substr(0, 3) : firstPageVal.substr(0, firstPageVal.length);
                lastPageVal = (lastPageVal.length > 2) ? lastPageVal.substr(0, 3) : lastPageVal.substr(0, lastPageVal.length);
                if (sIndex == eIndex) {
                    rtnArr.push({
                        page: page,
                        value: firstPageVal
                    });
                } else {
                    rtnArr.push({
                        page: page,
                        value: firstPageVal + " - " + lastPageVal
                    });
                }
            }
        }
        return rtnArr;
    }

    getFileExtension = (filename: string) => {
        if (!!filename) {
            return filename.substring(filename.lastIndexOf('.') + 1);
        }
        return null;
    }

    getTitleWthExt = (post: any) => {
        if (!!post) {
            let ext = this.getFileExtension(post.filename);
            if (!!post.title && ext != '') {
                return post.title + '.' + ext;
            }
        }
        return null;
    }

    getFileName = (filename: string) => {
        if (!!filename) {
            return filename.substring(0, filename.lastIndexOf('.'));
        }
        return null;
    }

    getFileSize(bytes) {
        var thresh = 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }

    checkTimePickerMdl = (elId, mdl) => {
        let hh = ($('#' + elId + ' input[name="time_HH"]').scope() as any);
        let mm = ($('#' + elId + ' input[name="time_MM"]').scope() as any);

        if (!!mdl || ((!!hh && !!hh.time[hh.type]) || (!!mm && !!mm.time[mm.type]))) {
            return true;
        }
        return false;
    }

    resetTimePicker = (elId, mdl) => {
        let hh = ($('#' + elId + ' input[name="time_HH"]').scope() as any);
        let mm = ($('#' + elId + ' input[name="time_MM"]').scope() as any);

        if (!!hh && hh.time[hh.type] == undefined && !!mm && mm.time[mm.type] == undefined) {
            return null;
        } else if (!!mdl && !!hh && hh.time[hh.type] == undefined) {
            let hr = mdl.getHours();
            if (hr < 12) {
                mdl.setHours(0);
            } else {
                mdl.setHours(12);
            }
        } else if (!!mdl && !!mm && mm.time[mm.type] == undefined) {
            mdl.setMinutes(0);
        }
        return mdl;
    }
}

angular.module('eCareVault.common.services')
    .service('UtilityService', UtilityService);

